import React from "react"

import {kebabCase} from "lodash"
import PropTypes from "prop-types"

import {useIsResponsive} from "../../hooks/useIsResponsive"
import colors from "../../styles/_default.colors.module.scss"
import Accordion from "../Accordion/Accordion"
import Segment from "../Segment/segment"

import "./responsiveSegment.scss"

const ResponsiveSegment = ({
    accordionProps = {openedOnMount: true},
    borderColor = colors.neutral200,
    children,
    className,
    headerBackgroundColor = colors.darkBlue50,
    headerTextColor = colors.darkBlue800,
    title,
}) => {
    const isResponsive = useIsResponsive()
    const headerTitleId = `responsive-segment-title-${kebabCase(title)}`

    return isResponsive ? (
        <div className="accordion-container">
            <Accordion borderless fluid {...accordionProps}>
                <div className={className} title={title}>
                    {children}
                </div>
            </Accordion>
        </div>
    ) : (
        <Segment
            body={{
                backgroundColor: colors.white,
                borderColor,
                content: (
                    <div className={`segment-content-container${className ? ` ${className}` : ""}`}>{children}</div>
                ),
            }}
            header={{
                content: (
                    <h3 id={headerTitleId} style={{color: headerTextColor}}>
                        {title}
                    </h3>
                ),
                backgroundColor: headerBackgroundColor,
                color: headerTextColor,
                withBorder: true,
            }}
        />
    )
}

ResponsiveSegment.propTypes = {
    accordionProps: PropTypes.object,
    borderColor: PropTypes.string,
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    headerBackgroundColor: PropTypes.string,
    headerTextColor: PropTypes.string,
    title: PropTypes.string.isRequired,
}

export default ResponsiveSegment
